import React, { useState, useEffect } from 'react';
import '../assets/Variablepopup.css';
import WoocommerceAPI from '../IPSAPI/WoocommerceAPI'; 

const VariablePopup = ({ show, orderbump, baseurl, selectedPrice, setSelectedPrice, orderbumpAddToCart, handleClose }) => {
  const [isSelectionMade, setIsSelectionMade] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [variationset, setVariationSet] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  /*
  const handleSelectionChange = (e) => {
    if (e.target.value !== '') {
      setIsSelectionMade(true);
    } else {
      setIsSelectionMade(false);
    }
  };
  */


  const handleSelectionChange = () => {
    const variationSelects = document.querySelectorAll('.ips-orderbumps select');
    const updatedOptions = [];
    let allOptionsSelected = true;

    variationSelects.forEach(select => {
      const attributeName = select.getAttribute('data-attribute_name');
      const selectedValue = select.value;
      const selectedOption = select.options[select.selectedIndex];
      const selectedSlug = selectedOption.getAttribute('data-slug');
  
     // console.log("Attribute Name: ", attributeName);
     // console.log("Selected Value: ", selectedValue);
     // console.log("Selected Slug: ", selectedSlug);

      if (selectedValue === '') {
        allOptionsSelected = false;
      }
  
      updatedOptions.push({ attribute: attributeName, value: selectedSlug });
    });

    setSelectedOptions(updatedOptions);
    //setIsSelectionMade(updatedOptions.every(option => option.value !== ''));
    setIsSelectionMade(allOptionsSelected);

    
  };


  useEffect(() => {
   // console.log("Selecton now: ", selectedOptions);
    if(orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-variationprices']){
     // console.log("Variation_Pricearray: ",orderbump[0]['ips-mb-ordebumps-offer-variationprices']);
    }
    
  }, [selectedOptions, orderbump]);


  useEffect(() => {
    if (isSelectionMade) {
      const price = getPriceForSelectedOptions(selectedOptions, orderbump[0]['ips-mb-ordebumps-offer-variationprices']);
      setSelectedPrice(price);
    }
  }, [isSelectionMade, selectedOptions]);


  /*
  useEffect(() => {
    console.log("Selecton ALL selections.");
    let variationprices_array = null;


  
    if (orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-variationprices']) {
      variationprices_array = orderbump[0]['ips-mb-ordebumps-offer-variationprices'];
      console.log("Variation_PRICES_Array XY: ",variationprices_array);
    }

    if (Array.isArray(variationprices_array) && variationprices_array.length > 0) {
      console.log("Selection XY: ",selectedOptions);
      const price = getPriceForSelectedOptions(selectedOptions, variationprices_array);
      console.log("Price for selected options:", price);
  } else {
      console.log("Variation prices array is empty or not an array.");
  }

  }, [isSelectionMade]);
*/


  const getPriceForSelectedOptions = (selectedOptions, variationprices_array) => {
   // console.log("Selected Options: ", selectedOptions);
    for (const variation of variationprices_array) {
     //   console.log("Variation: ", variation);
        let match = true;
        for (const option of selectedOptions) {
            const attributeKey = convertAttributeKey(option.attribute);
            //const optionValue = option.value.toLowerCase(); // Konvertiere den Optionswert in Kleinbuchstaben
            const optionValue = option.value;

       //     console.log("attributeKey: ", attributeKey);
       //     console.log("optionValue: ", optionValue);
       //     console.log("-------------------");
       //     console.log("variation.attributes: ", variation.attributes);
            // Überprüfen Sie, ob variation.attributes definiert ist und ob attributeKey ein gültiger Schlüssel ist
            if (variation.attributes && attributeKey in variation.attributes) {
                const variationAttributeValue = variation.attributes[attributeKey].toLowerCase(); // Konvertiere den Attributwert in Kleinbuchstaben
           //     console.log("variationAttributeValue: ", variationAttributeValue);

                // Wenn der Attributwert nicht mit dem Optionswert übereinstimmt und nicht leer ist, oder der Optionswert leer ist, dann ist es keine Übereinstimmung
                if ((variationAttributeValue !== optionValue && variationAttributeValue !== '') && optionValue !== '') {
               //     console.log("Match 1");
                    match = false;
                    break;
                }
            } else {
             //   console.log("Match 2");
                // Wenn das Attribut nicht gefunden wurde, setze match auf false
                match = false;
                break;
            }
        }
        if (match) {
          //  console.log("Match END");
          //  console.log("Price: ",variation.price);
            return variation.price;
        }
    }
    return null; // Wenn keine Übereinstimmung gefunden wurde
};


// Funktion zur Konvertierung des Attributschlüssels
const convertAttributeKey = (attribute) => {
  return attribute.replace('attribute_pa_', 'attribute_pa_').toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');
};


  /*
  const handleSelectionChange = (e) => {
    const allDropdowns = document.querySelectorAll('.ips-orderbumps select');
    let allSelected = true;

    allDropdowns.forEach((dropdown) => {
      if (dropdown.value === '') {
        allSelected = false;
      }
    });
    setIsSelectionMade(allSelected);

    console.log("Variation SET: ",variationset);
  };
*/


  useEffect(() => {
    get_Orderbump_variationdata();
    
    setModalVisible(show);

    if (!show) {
      // Wenn das Popup geschlossen wird, setze die Auswahl zurück
      setIsSelectionMade(false);
    }
  }, [show]);


  const get_Orderbump_variationdata = async () => {

    if(orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-variationset']){
      
    //const productid = parseInt(orderbump[0]['ips-mb-ordebumps-offer-product'], 10);
    

    //console.log("Orderbump-variationset: ",orderbump[0]['ips-mb-ordebumps-offer-variationset']); 
    //const response =  await WoocommerceAPI.ips_orderbumps_variation(baseurl, productid);

    const response =  orderbump[0]['ips-mb-ordebumps-offer-variationset'];
  
  //  console.log("VARIATIONSET: ",response["ob_offer_variationset"]);
    // setVariationSet(response["orderbumpvariationset"]);
    setVariationSet(response["ob_offer_variationset"]);
  }else{
    //console.log("No Orderbump productid");
  }

  }


  



  const handleButtonClick = () => {
   // console.log("Button wurde geklickt!");
    const productid = parseInt(orderbump[0]['ips-mb-ordebumps-offer-product'], 10);
    const quantity = parseInt(orderbump[0]['ips-mb-ordebumps-offer-quantity']);
    const producttyp = "variable";


     //-------------------------- Select Variations -----------------------------
     const selectedOptions = [];
     const variationSelects = document.querySelectorAll('.ips-orderbumps select');
 
     variationSelects.forEach(select => {
       const attributeName = select.getAttribute('data-attribute_name');
       const selectedValue = select.value;
       const selectedOption = select.options[select.selectedIndex];
       const selectedSlug = selectedOption.getAttribute('data-slug');
 
      // console.log("Attribute Name: ",attributeName);
      // console.log("Selected Value: ",selectedValue);
      // console.log("Selected Slug: ", selectedSlug);
   
       selectedOptions.push({ attribute: attributeName, value: selectedSlug });
     });
    // console.log("Selected Array: ",selectedOptions);
     //-------------------------------------------------------------------------
    

    orderbumpAddToCart(productid, quantity, producttyp, selectedOptions, orderbump);
    // Fügen Sie hier die gewünschte Funktionalität für den Button hinzu
  };

  return (
    <>
    {modalVisible && (
    <div>
      <div className="bootstrap-ips container mt-1 mb-0" > 
        {show && (
          <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
        )}
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog ips-modal-orderbumppopup modal-dialog-centered">
            <div className="modal-content ips-modal-content-orderbumppopup">
              <div className="modal-header">
              {orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-product-name'] && (
               <h5 class="modal-title text-center w-100">{orderbump[0]['ips-mb-ordebumps-offer-product-name']}</h5>
              )}
                <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
              </div>
              <div className="modal-body">
        
                <div className="d-flex align-items-center flex-row mt-1">
                <div className="col-md-6">
                {orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-product-image'] && (
                <div className="d-flex justify-content-center align-items-center mt-1 mb-1 my-auto ips_orderimgmobile" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-product-image'] }}></div>
                )}
                </div>
                <div className="col-md-6 pe-3 text-start">
                <div className="d-flex justify-content-start align-items-center flex-row m-1">
                {orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-pricerange'] && selectedPrice ? (
                <div className="d-flex flex-row ips-orderbump-total" style={{ fontWeight: 400, textDecoration: 'line-through' }} dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-pricerange'] }}></div>
              ) : (
                <div className="d-flex flex-row ips-orderbump-total" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-pricerange'] }}></div>
              )}
              
              </div>

              <div className="d-flex justify-content-start align-items-center flex-row m-1">

                
              {selectedPrice && (
                  <div className="d-flex flex-row ips-orderbump-total" dangerouslySetInnerHTML={{ __html: selectedPrice}}></div>
                        
                        )}
                        </div>

                <div className="d-flex justify-content-start align-items-center flex-row m-1">
                {orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-description'] && (
              <div className="modal-title">{orderbump[0]['ips-mb-ordebumps-offer-description']}</div>
              )}

                  </div>
                  <div className="d-flex align-items-start row p-0 mt-1">
                
  {Object.keys(variationset).map((attributeName, index) => (
    <div key={index} className="row align-items-center p-0 pe-3 mt-1">
      <div className="col-md-4">
        <label className="me-2"><b>{attributeName}</b></label>
      </div>
      <div className="col-md-8 ips-orderbumps align-items-center ">
        <select
          id={`pa_${attributeName.toLowerCase()}`}
          name={`attribute_pa_${attributeName.toLowerCase()}`}
          data-attribute_name={`attribute_pa_${attributeName.toLowerCase()}`}
          data-show_option_none="yes"
          onChange={handleSelectionChange}
        >
          <option value="">Wähle eine Option</option>
          {variationset[attributeName].map((option, optionIndex) => (
            <option key={optionIndex} value={option[0]} data-slug={option[1]} className="attached enabled">
              {option[0]}
            </option>
          ))}
        </select>
      </div>
    </div>
  ))}

                  </div>
                  </div>

                </div>
         
              </div>
              <div className="modal-footer row">
              <div className="d-flex justify-content-center flex-row mt-1">	
                  <div className="col-md-12 text-center">
                  <button
                  type="submit"
                  name="add-to-cart"
                  value="747643"
                  className={`cfw-primary-btn single_add_to_cart_button button ${isSelectionMade ? '' : 'disabled'}`}
                  disabled={!isSelectionMade}
                  onClick={handleButtonClick}
                >
                  {orderbump && orderbump[0] && orderbump[0]['ips-mb-ordebumps-offer-offertext'] ? orderbump[0]['ips-mb-ordebumps-offer-offertext'] : ''}
                </button>
                  </div>
                  {/*<div className="col-md-6 text-end">
                    <button type="submit" className="btn btn-secondary" onClick={handleClose}>
                      Schließen
                    </button>
                  </div>
                */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )}
    </>
  );
};

export default VariablePopup;